import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem("i18nextLng") || "fr",
    fallbackLng: "fr",
    supportedLngs: [
      "en",
      "fr",
      "es",
      "he",
      "de",
      "bg",
      "hr",
      "da",
      "et",
      "fi",
      "el",
      "hu",
      "it",
      "nl",
      "pl",
      "pt",
      "ro",
      "sv",
      "nb",
      "cs",
      "ru",
      "ar",
      "uk",
      "ta",
      "yue",
      "fa",
    ],
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
